module.exports = {
          srcSet: __webpack_public_path__ + "48d4c803b0b1b2f676fd356bca6f128c-16.png"+" 16w",
          images:[ {path: __webpack_public_path__ + "48d4c803b0b1b2f676fd356bca6f128c-16.png",width: 16,height: 16}],
          src: __webpack_public_path__ + "48d4c803b0b1b2f676fd356bca6f128c-16.png",
          toString:function(){return __webpack_public_path__ + "48d4c803b0b1b2f676fd356bca6f128c-16.png"},
          
          width: 16,
          height: 16
        }